import PropertyDataRightSection from './PropertyDataRightSection';

export default PropertyDataRightSection;
